
export enum HintPosition {
  BelowLeft = 'below-left',
  AboveRight = 'above-right',
}
